import { lazy } from "react";
import { IRoute } from "./types";

const NotFound = lazy(() => import("pages/exceptions/NotFound"));

const CanestarProduct = lazy(
  () => import("pages/dashboard/menu/canestar_product")
);
const Product = lazy(() => import("pages/dashboard/menu/product"));
const ProductChangePrice = lazy(() => import("pages/dashboard/menu/product/change_price"));
const Machine = lazy(() => import("pages/dashboard/core/machine"));
const Locations = lazy(() => import("pages/dashboard/core/location"));
const Trips = lazy(() => import("pages/dashboard/core/trip"));
const MachineSingle = lazy(() => import("pages/dashboard/core/machine/id"));
const Dashboard = lazy(() => import("pages/dashboard"));
const BankCheck = lazy(() => import("pages/dashboard/finance/bank_check"));
const InvoiceByDay = lazy(
  () => import("pages/dashboard/finance/invoice_by_day")
);
const Invoices = lazy(() => import("pages/dashboard/finance/invoice"));

const dashboardRoutes: IRoute[] = [
  {
    key: "/dashboard",
    path: "/dashboard",
    component: <Dashboard />,
  },
  {
    key: "/dashboard/finance/bank_check",
    path: "/dashboard/finance/bank_check",
    component: <BankCheck />,
  },
  {
    key: "/dashboard/finance/invoice_by_day",
    path: "/dashboard/finance/invoice_by_day",
    component: <InvoiceByDay />,
  },
  {
    key: "/dashboard/finance/invoice",
    path: "/dashboard/finance/invoice",
    component: <Invoices />,
  },
  {
    key: "/menu/canestar_product",
    path: "menu/canestar_product",
    component: <CanestarProduct />,
  },
  {
    key: "/menu/product",
    path: "menu/product",
    component: <Product />,
  },
  {
    key: "/menu/product/change_price/id",
    path: "menu/product/change_price/:id",
    component: <ProductChangePrice />,
  },
  {
    key: "/core/machine",
    path: "core/machine",
    component: <Machine />,
  },
  {
    key: "/core/location",
    path: "core/location",
    component: <Locations />,
  },
  {
    key: "/core/trip",
    path: "core/trip",
    component: <Trips />,
  },
  {
    key: "/core/machine/id",
    path: "core/machine/:id",
    component: <MachineSingle />,
  },
  {
    key: "/dashboard/finance/invoice",
    path: "/dashboard/finance/invoice",
    component: <Invoices />,
  },
  {
    key: "not_found",
    path: "*",
    component: <NotFound />,
  },
];
export default dashboardRoutes;
